import { render, staticRenderFns } from "./BottomSheetNotGranted.vue?vue&type=template&id=5d2c969c&scoped=true&"
import script from "./BottomSheetNotGranted.vue?vue&type=script&lang=js&"
export * from "./BottomSheetNotGranted.vue?vue&type=script&lang=js&"
import style0 from "./BottomSheetNotGranted.vue?vue&type=style&index=0&id=5d2c969c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2c969c",
  null
  
)

export default component.exports